import { render, staticRenderFns } from "./Qtck.vue?vue&type=template&id=613705d4&scoped=true&"
import script from "./Qtck.vue?vue&type=script&lang=js&"
export * from "./Qtck.vue?vue&type=script&lang=js&"
import style0 from "./Qtck.vue?vue&type=style&index=0&id=613705d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613705d4",
  null
  
)

export default component.exports